import api from './api';

/**
 * Support Ticket Service - SVT Admin API
 * Handles all support ticket operations for SVT Portal admins
 */

export const supportAPI = {
  // Tickets
  getTickets: (params) => api.get('/api/support/tickets', { params }),
  getTicket: (id) => api.get(`/api/support/tickets/${id}`),
  updateTicket: (id, data) => api.put(`/api/support/tickets/${id}`, data),
  addComment: (id, data) => api.post(`/api/support/tickets/${id}/comments`, data),
  addAttachment: (id, data) => api.post(`/api/support/tickets/${id}/attachments`, data),

  // Stats
  getStats: () => api.get('/api/support/stats'),

  // Clients (API key management)
  getClients: () => api.get('/api/support/clients'),
  createClient: (data) => api.post('/api/support/clients', data),
  updateClient: (id, data) => api.put(`/api/support/clients/${id}`, data),

  // Technicians (for assignment dropdown)
  getTechnicians: () => api.get('/api/support/technicians')
};

// Status badge colors
export const STATUS_COLORS = {
  new: { bg: '#e0f2fe', text: '#0369a1', label: 'New' },
  open: { bg: '#fef3c7', text: '#92400e', label: 'Open' },
  in_progress: { bg: '#dbeafe', text: '#1e40af', label: 'In Progress' },
  on_hold: { bg: '#fae8ff', text: '#86198f', label: 'On Hold' },
  resolved: { bg: '#d1fae5', text: '#065f46', label: 'Resolved' },
  closed: { bg: '#f3f4f6', text: '#374151', label: 'Closed' }
};

// Priority badge colors
export const PRIORITY_COLORS = {
  low: { bg: '#d1fae5', text: '#065f46', label: 'Low' },
  medium: { bg: '#fef3c7', text: '#92400e', label: 'Medium' },
  high: { bg: '#fed7aa', text: '#c2410c', label: 'High' },
  urgent: { bg: '#fee2e2', text: '#991b1b', label: 'Urgent' }
};

// Category labels
export const CATEGORIES = {
  IT: 'IT Support',
  Website: 'Website',
  Portal: 'Portal',
  Hardware: 'Hardware',
  Other: 'Other'
};

// Format time difference for display
export const formatTimeAgo = (dateString) => {
  if (!dateString) return 'N/A';

  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;

  return date.toLocaleDateString();
};

// Calculate SLA time remaining/overdue
export const calculateSLA = (createdAt, priority) => {
  // SLA targets in hours
  const slaTargets = {
    urgent: 1,
    high: 4,
    medium: 8,
    low: 24
  };

  const created = new Date(createdAt);
  const now = new Date();
  const elapsedHours = (now - created) / 3600000;
  const targetHours = slaTargets[priority] || 8;
  const remainingHours = targetHours - elapsedHours;

  if (remainingHours > 0) {
    return {
      status: 'within',
      hours: remainingHours.toFixed(1),
      label: `${remainingHours.toFixed(1)}h remaining`
    };
  } else {
    return {
      status: 'overdue',
      hours: Math.abs(remainingHours).toFixed(1),
      label: `${Math.abs(remainingHours).toFixed(1)}h overdue`
    };
  }
};

export default supportAPI;
